'use strict';
 /**
 * @author Maxim Seredkin
 */
export default ['$uibModal', 'OkvedRestService',
    function ($modal, OkvedRestService) {

        return {
            select: select,
            edit: edit,
            create: create,
            api: OkvedRestService
        };

        function select(okved, okveds) {
            return $modal.open({
                template: require('../view/okved-modal-select.html'),
                controller: 'OkvedModalSelectController',
                size: 'md',
                backdrop: false,
                resolve: {
                    okved: function () {
                        return okved;
                    },
                    okveds: function () {
                        return okveds
                    }
                }
            });
        }

        function create() {
            return $modal.open({
                template: require('../view/okved-modal-create.html'),
                controller: 'OkvedModalCreateController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: false,
                resolve: {
                    okved: function () {
                        return {};
                    }
                }
            });
        }

        function edit(item) {
            return $modal.open({
                template: require('../view/okved-modal-create.html'),
                controller: 'OkvedModalCreateController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: false,
                resolve: {
                    okved: function () {
                        return item;
                    }
                }
            });
        }

    }];